export const linkedIn: string = 'https://bit.ly/michael-minor-linkedin-resume';
export const linkedInLiteral: string = 'linkedin.com/in/WhyDoYouWork';
